import { Plan } from '@/shared/types/Billing';

type GetPlanPricesToRender = {
  activePricingCardPlanPrices: Plan['prices'];
  hasInactiveSubscription: boolean;
  userPlanPriceId?: string;
};

export const getPlanPricesToRender = ({
  activePricingCardPlanPrices,
  hasInactiveSubscription,
  userPlanPriceId,
}: GetPlanPricesToRender) => {
  const userPrice = activePricingCardPlanPrices.find((price) => price.id === userPlanPriceId);

  return activePricingCardPlanPrices.filter((price) => {
    if (userPrice && userPrice.status === 'archived' && !hasInactiveSubscription) {
      const matchesActivePriceWithDifferentInterval =
        price.status === 'active' && price.recurring?.interval !== userPrice.recurring?.interval;

      return price.id === userPrice.id || matchesActivePriceWithDifferentInterval;
    }

    return price.status === 'active';
  });
};
